<div>
</div>

<style>
  div {
    width: 210px;
    height: 230px;
    background: url('/images/stamps/undiscovered.png') center no-repeat;
    background-size: contain;
    /* opacity: .35; */
    /* filter: drop-shadow(5px 5px 5px); */
  }

  div:first-child {
    transform: rotate(50deg);
    z-index: 2;
  }

  div:nth-child(2) {
    transform: rotate(-29.48deg);
  }

  div:nth-child(3n) {
    transform: rotate(-57.66deg);
  }

  div:last-child {
    transform: rotate(9deg);
  }
</style>